<main>
  <header>
    <div>
      <p>
        <a routerLink="/home">
          {{title}} @if (!prod) {
          (UAT)
          }
        </a>
      </p>
      @if(full_name) {
        <p><a [routerLink]="" (click)="showNav()">{{full_name}} <mat-icon>person</mat-icon></a></p>
      } @else if(user_name) {
        <p><a [routerLink]="" (click)="showNav()">{{user_name}} <mat-icon>person</mat-icon></a></p>
      } @else {
        <p><a [routerLink]=""></a></p>
      }
    </div>
    <nav class="{{navClass}}">
      <ul>
        <!-- <li>{{user_name}}</li> -->
        @if (dealer) {
          @if(role === 'DEALER' || role === 'INT_DEALER') {
            <li>PA Code: {{dealer}}</li>
          }
          @else if(role === "FLEET") {
            <li>FIN Code: {{dealer}}</li>
          }
        }
        @if(admin) {
          <li><a routerLink="/account-info"><mat-icon>account_circle</mat-icon> Account Info</a></li>
        }
        <li><a [routerLink]="" (click)="logout()"><mat-icon>logout</mat-icon> Log Out</a></li>
      </ul>
    </nav>
  </header>

  <article (click)="closeNavIfOpen()">
    <router-outlet></router-outlet>
  </article>

  <footer (click)="closeNavIfOpen()">
    <nav>
      <a routerLink="/contact" id="contact">
        <mat-icon>contact_page</mat-icon> Contact
      </a>
      <a routerLink="/faq" id="faq">
        <mat-icon>quiz</mat-icon> FAQ
      </a>
      <a routerLink="/privacy" id="faq">
        <mat-icon>policy</mat-icon> Privacy
      </a>
    </nav>
  </footer>
</main>